module.exports = __webpack_public_path__ + "img/tp4.a163d05c.png";